import React from 'react'


export default function AboutUs() {
  const bannerstyle = {
    margin: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
  return (
    <div>
      
        <section className="banner" style={bannerstyle}>
           <div className="container-fluid">
               <div className="row">
                   <div className="col-md-12 p-0">
                       <div className="sub-banner">
                          <img src="/assets/img/banner-about.jpg" className="d-block w-100" alt="..." />
                          
  
                       </div>
                   </div>
               </div>
           </div>
           <div className="container aboutHead">
                <div className="row">
                    <div className="col-md-12">
                         <h1>About Us</h1>
                    </div>
                </div>
           </div>
       </section>

      <div className="container">
        <div className='row'>
          <div className='col-md-12 my-4'>
      <p>At Unlock Destinations, we believe that travel is more than just a getaway—it's an opportunity to experience the world, embrace new cultures, and create memories that last a lifetime. As travel enthusiasts ourselves, we're passionate about helping others uncover the magic of destinations, both near and far.<br /><br />

      Founded by a team of explorers who've roamed the globe, we understand that each trip is a personal journey. Whether you're looking for a peaceful escape in nature, an adrenaline-packed adventure, or a cultural immersion, we're here to craft the perfect holiday package that aligns with your dream getaway. Our carefully curated travel experiences are designed to cater to every type of traveler, offering unique itineraries that blend relaxation with discovery, luxury with authenticity.<br /><br />

      We don't just plan vacations; we bring your travel dreams to life, offering bespoke holiday packages that allow you to connect with the world in meaningful ways. With our extensive knowledge, personalized service, and a genuine love for exploration, we ensure that every trip you take with us feels like an adventure of its own.<br /><br />

      Join us as we wander the world, together, creating experiences that leave a mark on your heart—and an urge to pack your bags for the next journey!</p>
   </div> 
    </div>
    </div>

    </div>
  )
}
